// extracted by mini-css-extract-plugin
export var actionButton = "_mm-0";
export var actionMenuContainer = "_mm-i";
export var bubble = "_mm-2";
export var bubbleActionMenu = "_mm-j";
export var bubbleContext = "_mm-6";
export var bubbleItems = "_mm-7";
export var customer = "_mm-3";
export var divider = "_mm-8";
export var fileList = "_mm-9";
export var hiddenComment = "_mm-o";
export var infoAbove = "_mm-a";
export var internal = "_mm-4";
export var lightActionButton = "_mm-1";
export var link = "_mm-b";
export var merchant = "_mm-5";
export var message = "_mm-c";
export var profilePicture = "_mm-e";
export var quillToolbarContainer = "_mm-f";
export var senderDate = "_mm-g";
export var senderDateCustomer = "_mm-h";
export var senderName = "_mm-d";
export var time = "_mm-k";
export var uploadedImage = "_mm-l";
export var username = "_mm-m";
export var xsmall = "_mm-n";